// extracted by mini-css-extract-plugin
export var border = "_n-7";
export var brand = "_n-r";
export var button = "_n-j";
export var center = "_n-9";
export var centered = "_n-5";
export var closeButton = "_n-b";
export var disabledWrapper = "_n-k";
export var error = "_n-n";
export var extraLarge = "_n-4";
export var extraSmall = "_n-1";
export var fill = "_n-g";
export var footer = "_n-f";
export var footerAction = "_n-h";
export var footerButtons = "_n-i";
export var header = "_n-6";
export var icon = "_n-m";
export var info = "_n-q";
export var inline = "_n-8";
export var large = "_n-3";
export var main = "_n-c";
export var modal = "_n-0";
export var neutral = "_n-s";
export var noPadding = "_n-e";
export var none = "_n-t";
export var scrollable = "_n-d";
export var small = "_n-2";
export var success = "_n-p";
export var tight = "_n-l";
export var titleIcon = "_n-a";
export var warn = "_n-o";